export const uk = {
  // terms of use
  terms_of_use: {
    title: 'Умови користування',
    subtitle: 'Починаючи користування, ви погоджуєтесь з ',
    link: 'умовами використання.',
    button_text: 'Прийняти',
  },

  // main page
  main_page: {
    stars: 'СТАРС',
    pending: 'пендінг',
    available: 'доступний',
    replenish: 'Поповнити',
    send: 'Відправити',
    bring_out: 'Вивести',
    history_of_transactions: 'Історія транзакцій',
    total_balance: 'Загальний баланс',
  },

  // menu
  menu: {
    language: 'Мова',
    delete_data: 'Видалення даних',
    enter_promo_code: 'Ввести промокод',
    ton_wallet: 'Ton Wallet',
    support: 'Підтримка',
    exit: 'Вихід',
    history_of_transaction: 'Історія транзакцій',
  },

  // languages page
  language_page: {
    ukrainian: 'Українська',
    english: 'Англійська',
    russian: 'Російська',
    german: 'Німецька',
    choose: 'Обрати',
  },

  // delete page
  delete_page: {
    title: 'Що буде втрачено при видаленні акаунту?',
    warning: '*натискаючи кнопку, ви погоджуєтесь з наслідками',
    delete: 'Видалити',
    item_1: 'всі активні сесії будуть завершені.',
    item_2: 'відновлення акаунту буде неможливим.',
    item_3: 'усі транзакції, що відбулися, будуть втрачені.',
    item_4: 'кошти, що залишились на вашому балансі, не підлягають поверненню.',
  },

  // promo code page
  promo_code: {
    input_promo_below: 'Введіть свій промокод нижче, щоб отримати подарунок.',
    promo: 'Промокод',
    input_promo: 'Введіть промокод',
    recieve: 'Отримати',
  },

  // info container
  info_container: {
    ton_wallet: {
      connected: 'Підключено',
      not_connected: 'Не підключено',
      wallet_is_connected: 'Ваш гаманець успішно підключений.',
      wallet_is_not_connected: 'Наразі ваш гаманець не підключений. Скористайтеся кнопкою нижче.',
      connect: 'Підключити',
      turn_off_question: 'Хочете відключити?',
    },
    support: {
      need_help_question: 'Потрібна допомога?',
      contact_our_bot: 'Зверніться до нашого бота, і ми швидко вирішимо ваше питання.',
      write_bot: 'Написати боту',
    },
    go_out: {
      want_exit_question: 'Бажаєте вийти?',
      you_can_sign_in_again: 'Ви можете знову увійти в будь-який момент.',
      log_out_of_account: 'Вийти з акаунта',
    },
  },

  // bottles page
  bottles_page: {
    bottles: 'Банки',
    filter: 'Фільтр',
    create_bank: 'Створити банку',
    types: {
      my: 'Мої',
      participate: 'Беру участь',
      lottery: 'Лотерейні',
      charitable: 'Благодійні',
    },
    conditions: {
      star_on_tickets_exchange: '1 Star = 20 білетів',
      max_stars: 'Максимум на день: 10 Stars = 200 білетів',
      advertising_on_ticket_exchange: '1 перегляд реклами = 1 білет',
      max_advertising: 'Максимум: 100 реклам за день (10 реклам на годину)',
    },
  },

  // main bottle item
  main_bottle_item: {
    collected: 'Зібрано',
    to_end: 'До кінця',
    participants: 'Учасники',
    daily_lottery: 'Щоденна лотерея',
    viewing_ads: 'Перегляд реклами',
    modal: {
      tickets: 'Квитків на балансі:',
      how_works: 'Як працює розіграш?',
      description:
        'Участь у щоденній лотереї беруть тільки ті, хто зібрав білети — через обмін Stars або перегляд реклами.',
      item_1: '5 учасників отримають по 10% призового фонду.',
      item_2: '50 випадкових учасників виграють по 1% призу.',
      item_3: 'розіграш відбувається щодня автоматично о 00:00.',
      exchange: 'Обмін на білети',
      advertising: 'Рекламні білети',
      views: 'Доступно переглядів:',
    },
  },

  // bottle item
  bottle_item: {
    start_is_expected: 'Очікується старт',
    fixed: 'фіксована',
    any: 'довільна',
  },

  type_of_bottle: {
    lottery: {
      name: 'Лотерейна',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    },
    charitable: {
      name: 'Благодійна',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    },
    button: {
      text: 'Продовжити',
    },
  },

  create_bottle: {
    step: 'Крок {{step}}',
    choose_type_bank: 'Оберіть тип банки',
    input_name_bank: 'Введіть назву банки',
    input_target_bank: 'Введіть ціль банки',
    input_desired_amount: 'Введіть бажану суму входу',
    input_availability_period: 'Введіть період доступності банки',
    three_months_maximum: '(3 місяцф максимум)',
    set_date: 'Встановити дату',
    continue: 'Продовжити',
    on: 'На ',
    from: 'з',
    to: 'по',
    confirm_page: {
      title: 'Уважно перевірте дані!',
      subtitle: 'Після збереження банку не можна буде редагувати або видалити.',
    },
    popup: {
      text: 'Введіть бажану суму входу або пропустіть цей крок, щоб створити банку з будь-якою сумою входу.',
    },
  },

  attachment_to_bottle: {
    join_to_bottle: 'Долучитися до банки',
    input_amount: 'Введіть бажану суму вкладу для участі.',
    button: {
      text: 'Зробити вклад',
    },
    conditional: {
      depositing: 'Внесення вкладу',
      text: 'Натискаючи “Списати старси” на цьому екрані, з вашого акаунту буде списано зазначену кількість старсів для участі в цій банці.',
      reset_stars: 'Списати старси',
      cancel: 'Скасувати',
    },
  },

  status_page: {
    confirmation: {
      title: 'Банка створена',
      subtitle: 'Ваша банка успішно створена та готова до використання.',
      link_text: 'На головну',
    },
    error: {
      title: 'Дата перевищує дозволений термін',
      subtitle: 'Ви вказали дату, яка перевищує 3 місяці. Будь ласка, спробуйте ще раз.',
      link_text: 'Спробувати ще раз',
    },
    show_bottles: 'Переглянути банки',
  },

  skip: {
    pretermit: 'Пропустити',
  },

  // NoBottles page
  no_bottles_page: {
    reset_filters: 'Скину фільтри',
    nothing: {
      title: 'Нічого не знайдено',
      subtitle: 'Спробуйте змінити фільтри для кращого результату.',
    },
    no_own_bottles: {
      title: 'Немає власних банок',
      subtitle: 'Створіть банку прямо зараз за допомогою кнопки нижче.',
    },
    no_participations: {
      title: 'Відсутні участі в банках',
      subtitle: 'Щоб приєднатися до банки, отримайте посилання від його учасника.',
    },
  },

  // Filters block
  filters: {
    fixed: 'Фіксований',
    any: 'Довільний',
    active: 'Активні',
    planned: 'Заплановані',
    cancel: 'Скасувати',
    type_of_deposit: 'Тип суми вкладу',
    number_of_participants: 'Кількість учасників',
    up_to_number: 'до {{number}}',
    more_than_number: 'більше {{number}}',
    time_of_bank: 'Час банки',
    apply: 'Застосувати',
  },

  // bottle page
  bottle_page: {
    before_the_start: 'До старту залишилося',
    total_pool: 'Загальний пул',
    list_of_participants: 'Список учасників',
    join: 'Долучитися',
    increase_the_contribution: 'Підвищити вклад',
    join_for: 'Долучитися за',
    you_are_already_member: 'Ви вже є учасником',
    type: 'Тип',
    deposit_amount: 'Сума вкладу',
    owner: 'Власник',
    target: 'Ціль',
    ANY: 'довільна',
    FIXED: 'фіксована',
    CHARITABLE: 'благодійна',
    LOTTERY: 'лотерейна',
    exchange: {
      stars_for_tickets: 'Обміняти старси на білети',
    },
  },

  // small button
  button_small: {
    all: 'Всі',
  },

  // participants
  participants: {
    nickname_of_user: 'Нік юзера',
    deposit_and_interest: 'Вклад & відсоток',
    tickets_and_chance: 'К-ть квитків & шанс',
    show_me: 'Показати мене',
  },

  // confirmation info
  confirmation_info: {
    bank_type: 'Тип банки',
    bank_name: 'Назва банки',
    target_of_bank: 'Ціль банки',
    stars: '{{number}} старсів',
    bank_will_available: 'Банка буде доступна',
    any: 'Довільна',
    amount_received_bank: 'Сума входу до банки',
    from: 'з {{date}}',
    to: 'по {{date}}',
  },

  // referrals page
  referrals: {
    you_received: 'За допомогою рефералів ви отримали',
    my_referrals: 'Мої реферали',
    invite_friends: 'Запросити друзів',
  },

  // replenishment page
  replenishment: {
    title: 'Поповнення Stars',
    subtitle: 'Введіть суму для поповнення власного балансу Stars.',
  },

  // transactions page
  transactions_page: {
    today: 'Сьогодні',
    DEPOSIT: 'Поповнення',
    INVESTMENT: 'Вклад',
    TRANSFER: 'Переказ',
    WITHDRAWAL: 'Вивід',
    WIN: 'Виграш',
    LOSE: 'Програш',
  },

  transaction_input: {
    balance: 'Баланc {{balance}}',
    not_commission: 'Немає комісії',
    commission: 'Комісія {{commission}}',
    remainder: 'Залишок',
    share_receipt: 'Поділитися квитанцією',
    contact_support: 'Звернутися у підтримку',
    user_receive: 'отримаєте ~ {{value}}',
  },

  transaction_details: {
    status: {
      text: 'Статус',
      processing: 'В обробці',
      completed: 'Виконано',
    },
    receiver: 'Отримувач',
    withdrawal_type: {
      telegram: 'Вивід на телеграм акаунт',
      ton: 'Вивід в USDT(мережа TON)',
    },
  },

  // notifiaction page
  notifications_page: {
    title: 'Сповіщення',
    BOTTLE_WIN: 'Перемога!',
    BOTTLE_LOOSE: 'Поразка :(',
    name_bank: 'Назва банки',
    owner: 'Власник',
    result: 'Результат:',
  },

  months: {
    january: 'січня',
    february: 'лютого',
    march: 'березня',
    april: 'квітня',
    may: 'травня',
    june: 'червня',
    july: 'липня',
    august: 'серпня',
    september: 'вересня',
    october: 'жовтня',
    november: 'листопада',
    december: 'грудня',
  },

  sending_page: {
    title: 'Надсилання Stars',
    subtitle: 'Введіть username людини, якію бажаєте надіслати Stars.',
  },

  search_user: {
    results: 'Рузультати',
    not_found: 'Не знайдено...',
    invite_friend: 'Запросіть друга до системи за допомогою кнопки вище.',
  },

  sending_stars: {
    title: 'Надсилання Stars для {{username}}',
    subtitle: 'Введіть кількість старсів, яку бажаєте надіслати.',
    button_text: 'Надіслати',
  },

  withdrawal_page: {
    output_stars: 'Виведення Stars',
    choose_preferred_method: 'Оберіть бажаний спосіб виведення Stars.',
    available: 'Доступно:',
    in_account: 'В зірки на акаунт',
    in_ton: 'В USDT (мережа TON)',
    stars: {
      title: 'Виведення в справжні Stars на акаунт',
      subtitle: 'Введіть бажану суму для виведення Stars на поточний акаунт.',
      button_text: 'Вивести',
    },
    ton: {
      title: 'Виведення в крипту USDT(мережа TON)',
      subtitle: 'Введіть бажану суму від 500 Stars для виведення на ваш Ton Wallet. ',
      button_text: 'Вивести',

      wallet: {
        address: 'Ввеідть номер вашого Ton Wallet.',
      },
    },
  },

  not_enough_stars: {
    title: 'Недостатньо старсів',
  },
  withdraw: {
    title: 'Введіть мінімум 500 старсів для виводу',
  },
  limit_is_full: {
    title: 'Ваш ліміт на обмін вичерпано',
  },

  error_page: {
    update: 'Оновити',
    support_service: 'Служба підтримки',
    on_main: 'На головну',
    server: {
      title: 'Сервер не відповідає',
      description: "Виникли труднощі зі з'єднанням. Будь ласка, повторіть спробу пізніше.",
    },
    connect: {
      title: 'Інтернет відсутній',
      description: "Ваше інтернет-з'єднання перервано. Перевірте підключення.",
    },
    technical: {
      title: 'Технічні роботи',
      description: 'Сервер тимчасово недоступний. Дякуємо за терпіння!',
    },
    general: {
      failed_send: {
        title: 'Не вдалося надіслати',
        description: 'Сталася помилка під час надсилання старсів. Спробуйте пізніше.',
      },
      replenishment_failed: {
        title: 'Поповнення не вдалося',
        description: 'Сталася помилка обробки платежу. Спробуйте пізніше.',
      },
      something_went_wrong: {
        title: 'Щось пішло не так...',
        description: 'Сталася помилка. Спробуйте пізніше або зверніться до підтримки.',
      },
      bank_not_created: {
        title: 'Банка не створена',
        description: 'Не вдалося створити банку. Спробуйте пізніше або зверніться до підтримки.',
      },
      output_failed: {
        title: 'Виведення не вдалося',
        description: 'Не вдалося обробити заявку на виведення старсів. Спробуйте пізніше.',
      },
      join_to_bottle_failed: {
        title: 'Приєднання до банки не вдалося',
        description: 'Не вдалося обробити приєднання до банки. Спробуйте пізніше.',
      },
    },
  },

  // History participate
  history_participations: {
    label: 'Історія участі',
    titles: {
      broken: 'Розбиті',
      unbroken: 'Не розбиті',
    },
    bank: {
      titles: {
        WAITING: 'Чекаємо...',
        WIN: 'Перемога!',
        DEFEAT: 'Поразка :(',
        name: 'Назва банки',
        owner: 'Власник',
        periodOfTime: 'Проміжок часу',
      },
    },

    nothing: {
      title: 'Тут поки що пусто!',
      subtitle: 'У вас поки що немає жодної розбитої банки.',
      show_bank: 'Переглянути банки',
    },

    missing: {
      title: 'Історія участі відсутня',
      description: 'Ви ще не брали участь у жодній банці. Почніть зараз!',
      show_banks: 'Переглянути банки',
    },
  },

  // Confetti
  confetti: {
    type_of_confetti: {
      replenish: 'Поповнення успішне!',
      send: 'Надсилання успішне!',
      withdrawal: 'Заявку прийнято!',
    },
    description: {
      replenish: 'Баланс вашого акаунту Stars було успішно поповнено.',
      send: 'було надіслано {{numberOfStars}} Stars для {{username}}.',
      withdrawal: 'Статус операції можна відстежити в "Транзакціях". Розгляд займає до 24 годин.',
    },
    button: {
      on_main: 'На головну',
      show_banks: 'Переглянути банки',
    },
  },
}
